import { render } from "./CustomFieldRules.vue?vue&type=template&id=a5bb2438"
import script from "./CustomFieldRules.js?vue&type=script&lang=js"
export * from "./CustomFieldRules.js?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__